import { render } from "./LessonCatalogStoryComponent.vue?vue&type=template&id=42fb3e3f"
import script from "./LessonCatalogStoryComponent.vue?vue&type=script&lang=js"
export * from "./LessonCatalogStoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__